import { styled } from '@mui/system'
import { Box } from '@mui/material'
import type { Theme } from '@mui/material/styles'
import { shade } from '../../../colors'

interface WrapperProps {
  theme?: Theme
}

export const Wrapper = styled(Box)<WrapperProps>(({ theme }) => ({
  width: '100%',
  minHeight: theme.spacing(80),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}))

interface ImageWrapperProps {
  theme?: Theme
}

export const ImageWrapper = styled(Box)<ImageWrapperProps>(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: theme.spacing(12),
  height: theme.spacing(12),
  borderRadius: '50%',
  background: shade[200],
  marginBottom: theme.spacing(3)
}))
